import {
  AppBar, Button, Container, Grid, Toolbar, Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

import headerLogo from '../../assets/images/logo-revbits.png';
import darkLogo from '../../assets/images/theme-switch-dark.svg';
import lightLogo from '../../assets/images/theme-switch-light.svg';
import dmLogo from '../../assets/images/up-login-dm-logo.png';
import lmLogo from '../../assets/images/update_portal_login.png';
import styles from '../../assets/jss/NewLoginScreenStyles';
import { constants } from '../../constant/constant';
import { EncryptionServices } from '../../services';

// const requiredUserName = required("VALIDATION.REQ_USERNAME");

class AuthMethods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeAuth: {},
      previousType: '',
    };
  }

  componentDidMount() {
    const { history } = this.props;
    const { state } = history;
    let previousType = state && state.method ? constants.URL_AUTH[state.method] : '';
    const cred = JSON.parse(sessionStorage.getItem('cred'));
    if (cred?.token) {
      EncryptionServices.decodeJwtToken(cred.token).then((decryptToken) => {
        if (previousType === '') {
          previousType = decryptToken.defaultAuth;
        }

        const authMethods = {};
        authMethods.token2fa = decryptToken.activeAuth.otp;
        authMethods.sms2fa = decryptToken.activeAuth.sms;
        authMethods.u2f = decryptToken.activeAuth.u2f;

        this.setState({
          activeAuth: authMethods,
          previousType,
        });
      });
    }
  }

  createMethods = (classes) => {
    const methods = [];
    const {
      activeAuth,
      previousType,
    } = this.state;
    if (Object.keys(activeAuth).length) {
      Object.keys(activeAuth).map((res) => {
        if (activeAuth[res] && +previousType !== +constants.TFA_METHODS[res]) {
          methods.push(
            <Grid
              key={constants.TFA_METHODS[res]}
              item
              className={`${classes.formInput} ${classes.alignCenter}`}
            >
              <a href={`/${constants.LOGIN_METHODS_TYPE[constants.TFA_METHODS[res]]}`}>
                <Button className={`${classes.activeButton}`}>
                  Verify through
                  {' '}
                  {constants.LOGIN_METHODS_TEXT[res]}
                </Button>
              </a>
            </Grid>,
          );
        }
        return methods;
      });

      if (+previousType !== 4 && (activeAuth.sms2fa || activeAuth.token2fa || activeAuth.u2f)) {
        methods.push(
          <Grid key={3} item className={`${classes.formInput} ${classes.alignCenter}`}>
            <a href="/verify-recoveryCode">
              <Button className={`${classes.activeButton}`}>
                Verify
                through
                {constants.LOGIN_METHODS_TEXT.recoveryCode}
              </Button>
            </a>
          </Grid>,
        );
      }
    }

    return methods;
  };

  render() {
    const { classes, logo, changeTheme } = this.props;
    const methods = this.createMethods(classes);
    return (

      <div className={classes.main}>

        <AppBar position="static" className={classes.header}>
          <Toolbar>
            <img className={classes.headerLogo} src={headerLogo} alt="header logo" />
            <Typography variant="h6" className={classes.title} />
            <Button color="inherit" onClick={changeTheme}>
              {logo ? (
                <img src={darkLogo} alt="login logo" />
              ) : (
                <img src={lightLogo} alt="login logo" />
              )}

            </Button>
          </Toolbar>
        </AppBar>

        <Container maxWidth="xl" className={classes.mainLogin}>

          <Grid container spacing={0} style={{ height: '100%' }}>

            <Grid item xs={12} sm={12} md={6} lg={7} className={classes.loginLeft}>

              <Grid container spacing={0}>

                <Grid item xs={12}>
                  <div className="rightLogo">

                    {logo ? (
                      <img src={dmLogo} alt="login logo" />
                    ) : (
                      <img src={lmLogo} alt="" />
                    )}

                    <div style={{ alignSelf: 'center' }}>
                      <p>
                        Rev
                        <span>Bits</span>
                      </p>
                      <span>SOFTWARE UPDATE PORTAL</span>
                    </div>
                  </div>
                </Grid>

                <Grid item xs={12} />

              </Grid>

            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={5}
              style={{ display: 'flex' }}
              className={`${classes.loginRight} ${classes.heightSet}`}
            >

              <Grid
                container
                spacing={1}
                alignItems="flex-end"
                className={`${classes.alignCenter} ${classes.OTPScreen} ${classes.titleAlign}`}
              >
                <h2>Choose Verification Methods</h2>
              </Grid>
              <form
                name="loginForm"
                className="form-set"
                noValidate
                autoComplete="off"
              >
                <div className={classes.mobileBackgroundImage} />
                <Grid container spacing={1} alignItems="flex-end" className={classes.marginBottom}>
                  {methods}
                </Grid>
              </form>

            </Grid>

          </Grid>

        </Container>

        <AppBar className={classes.footer} position="fixed" color="primary">

          <Toolbar>
            <Typography variant="subtitle2" className={classes.title} style={{ textAlign: 'center' }}>
              ©
              {' '}
              {new Date().getFullYear()}
              {' '}
              RevBits Software Update Portal.
              <span>
                All Rights Reserved.
              </span>
            </Typography>
          </Toolbar>
        </AppBar>

      </div>
    );
  }
}

export default withTranslation()(withStyles(styles, { withTheme: true })(AuthMethods));
